import { testimonials } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const principles = [
  { icon: "ri-verified-badge-line", t: "基于公开信息", d: "所有脉络整理都尽量溯源到可查证的一手或权威报道。" },
  { icon: "ri-node-tree", t: "按发生顺序还原", d: "坚持把先后顺序理清楚，不为了流量打乱事件真实节奏。" },
  { icon: "ri-emotion-line", t: "理性、不煽风点火", d: "还原脉络是我们的目的，不做标题党，也不放大未证实说法。" },
  { icon: "ri-refresh-line", t: "持续修正更新", d: "收到新线索后会及时复核，确保脉络尽可能完整准确。" },
];

export default function Reputation() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="container-x grid gap-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <SectionHeading
            eyebrow="About Us"
            title="关于本站：脉络清晰，吃瓜不迷路"
            desc="本站是一个专注把“本月大瓜”按时间线整理成完整经过的文娱内容站点。我们相信，热闹不该是碎片拼凑，真正看懂一件大事，靠的是清清楚楚的前后顺序。"
          />
          <p className="mt-5 text-sm leading-7 text-foreground-600">
            从第一波信息放出的瞬间，到各方回应、舆论拐点再到逐渐收尾，我们把本月值得关注的大瓜逐一拆解成可读的脉络节点，
            让你用几分钟就能建立起对整件事的完整认知，不必再四处翻找、自行拼凑聊天记录与截图。
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.t} className="flex gap-3 rounded-xl bg-background-100 p-4 ring-1 ring-background-200">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-foreground-50">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <div>
                  <h4 className="text-sm font-bold text-foreground-950">{p.t}</h4>
                  <p className="mt-1 text-[13px] leading-5 text-foreground-600">{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-end justify-between">
            <h3 className="font-heading text-xl font-bold text-foreground-950">读者怎么说</h3>
            <div className="flex items-center gap-1 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
          </div>

          <div className="mt-5 grid flex-1 gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl bg-background-100 p-5 ring-1 ring-background-200">
                <div className="flex items-center justify-between">
                  <figcaption className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 font-heading text-sm font-bold text-secondary-900">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                  <i className="ri-double-quotes-r text-2xl text-accent-400"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-7 text-foreground-700">“{t.text}”</blockquote>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}